// Get tindakan notis (Senarai Tindakan table)
export const apiGetTindakanNotis = async () => {
  const department = getCurrentUserDepartment();
  const res = await apiFetch(`/api/notis/tindakan`, {
    method: 'GET',
    headers: { 'X-User-Department': department },
  });
  if (!res.ok) throw new Error('Failed to fetch tindakan notis');
  return res.json();
};
import { getCurrentUserDepartment } from "utils/userUtils";
import { apiFetch } from './apiFetch';

const BASE_URL = "/api";

// Upload notis and file
import { withCsrfHeaders, fetchWithCsrfRetry } from './csrf';

export const apiUploadNotis = async ({ notisList, notisFail, file }) => {
  const formData = new FormData();
  formData.append('notisList', JSON.stringify(notisList));
  formData.append('notisFail', JSON.stringify(notisFail));
  if (file) formData.append('file', file);
  const headers = await withCsrfHeaders();
  const res = await apiFetch(`/api/notis/upload`, { method: 'POST', headers, body: formData });
  if (!res.ok) throw new Error('Failed to upload notis');
  return res.json();
};

export const apiSyncAndGetNotis = async (options = {}) => {
  // By default, use stored notis_* flags (skip recompute) to match DB expectations.
  const useStored = options.useStored !== undefined ? !!options.useStored : true;
  const department = getCurrentUserDepartment();
  const headers = await withCsrfHeaders({
    "Content-Type": "application/json",
    "X-User-Department": department,
  });
  const qs = useStored ? `?useStored=1` : "";
  const res = await apiFetch(`${BASE_URL}/notis/sync${qs}`, { method: 'POST', headers });
  if (!res.ok) throw new Error("Failed to sync and fetch notis data");
  return res.json();
};

// Post notis: set mark_notis = 2 for the given invoices
export const apiPostNotis = async (no_inbois_list) => {
  const headers = await withCsrfHeaders({ 'Content-Type': 'application/json' });
  const res = await apiFetch(`/api/notis/post`, { method: 'POST', headers, body: JSON.stringify({ no_inbois_list }) });
  if (!res.ok) throw new Error('Failed to post notis');
  return res.json();
};

// Fetch all mark_notis=2 rows for UUU (ignoring department)
export const apiGetUUUPosted = async () => {
  const res = await fetch(`/api/notis/uuu-posted`, { method: 'GET' });
  if (!res.ok) throw new Error('Failed to fetch UUU posted notis');
  return res.json();
};

// Hapus notis by no_borang (resets inbois, deletes notis + notis_fail)
export const apiHapusNotis = async (no_borang) => {
  const headers = await withCsrfHeaders({ 'Content-Type': 'application/json' });
  const res = await apiFetch(`/api/notis/hapus`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ no_borang }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to delete notis');
  }
  return res.json();
};

// Fetch Borang Penyerahan list filtered by zon (and current department)
export const apiGetBorangPenyerahan = async (zon = "", noAkauns = []) => {
  const department = getCurrentUserDepartment();
  const params = new URLSearchParams();
  if (zon) params.set('zon', zon);
  if (Array.isArray(noAkauns) && noAkauns.length) params.set('noAkauns', noAkauns.join(','));
  const qs = params.toString() ? `?${params.toString()}` : '';
  const res = await apiFetch(`/api/notis/borang-penyerahan${qs}`, {
    method: 'GET',
    headers: { 'X-User-Department': department },
  });
  if (!res.ok) throw new Error('Failed to fetch borang penyerahan');
  return res.json();
};
